export const USER = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  SET_PROFILE: "SET_PROFILE"
};

export const CATEGORY = {
  GET_ALL: "GET_ALL"
}

export const RECIPES = {
  SET_QUERY: "SET_QUERY",
  SET_VIEW_TYPE: "SET_VIEW_TYPE",
  SET_SORT: "SET_SORT",
  SET_RECIPES_COUNT: "SET_RECIPES_COUNT",
  SET_PAGE_NUM: "SET_PAGE_NUM",
  SET_PAGE_PREV: "SET_PAGE_PREV",
  SET_PAGE_NEXT: "SET_PAGE_NEXT",
  SET_PAGE_SIZE: "SET_PAGE_SIZE",
  SET_WITH_IMAGES_ONLY: "SET_WITH_IMAGES_ONLY",
  SET_CATEGORY_FILTER: "SET_CATEGORY_FILTER"
};

export default {
  CATEGORY,
  RECIPES,
  USER
};
